export default __webpack_public_path__ + "img/11c689f8f744cc4b2a49aee8e4e64e67.png";